import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold" }, "임금기초", -1)
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = ["onDblclick", "onKeydown"]
const _hoisted_5 = { class: "tac" }
const _hoisted_6 = { class: "tac" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "tac" }
const _hoisted_9 = { class: "tar" }
const _hoisted_10 = { class: "tac" }
const _hoisted_11 = { class: "tar" }
const _hoisted_12 = { class: "tar" }
const _hoisted_13 = { class: "tar" }
const _hoisted_14 = { class: "tar" }
const _hoisted_15 = { class: "tar" }
const _hoisted_16 = { class: "tar" }
const _hoisted_17 = { class: "tar" }
const _hoisted_18 = { class: "tar" }
const _hoisted_19 = { class: "tar" }
const _hoisted_20 = { class: "tar" }
const _hoisted_21 = { class: "tar" }
const _hoisted_22 = { class: "tar" }
const _hoisted_23 = { class: "tar" }
const _hoisted_24 = { class: "tar" }
const _hoisted_25 = { class: "tar" }
const _hoisted_26 = { class: "tar" }
const _hoisted_27 = { class: "tar" }
const _hoisted_28 = { class: "tar" }
const _hoisted_29 = { class: "tar" }
const _hoisted_30 = { class: "tar" }
const _hoisted_31 = {
  key: 2,
  class: "tac"
}
const _hoisted_32 = {
  key: 3,
  class: "tac"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "마감완료", -1)
const _hoisted_34 = [
  _hoisted_33
]

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useStore } from 'vuex';
import axios from "axios";
import router from "../../../router";
import { WageBasicItem } from "../../../types/wage";

import AdminLoadingAction from "../../../components/admin/layout/AdminLoadingAction.vue";
import WageBasicEmpDelete from "../../../components/admin/wage/WageBasicEmpDelete.vue";
import WageBasicLoadEmp from "../../../components/admin/wage/WageBasicLoadEmp.vue";
import WageBasicLoadNowEmp from "../../../components/admin/wage/WageBasicLoadNowEmp.vue";
import WageLedgerPayDate from "../../../components/admin/wage/WageLedgerPayDate.vue";
import FormatMonth from "../../../components/api/FormatMonth.vue";

interface Header {
  title: string;
  key?: string;
  align: string;
  sortable: boolean;
  children?: Header[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageBasic',
  setup(__props) {

const store = useStore();
const loading = ref<boolean>(false);
const code = ref<string>(store.state.AdminSisulCode);
const date = ref<string>(store.state.AdminYYMM);
const search = ref<string>("");
const empWageBasicList = ref<WageBasicItem[]>([]);
const endEmpStatus = ref<boolean>(false);

const handleKeydown = (item: WageBasicItem, event: KeyboardEvent) => {
  if (event.ctrlKey && event.key === 'Enter') {
    updateEmpWageBasic(item);
  }
};
const onEdit = (item: WageBasicItem) => {
  if(!endEmpStatus.value){
    return;
  }
  item.originalItem = { ...item };
  item.isEditing = true;
};
const outEdit = (item: WageBasicItem) => {
  if (item.originalItem) {
    Object.assign(item, item.originalItem);
  }
  item.isEditing = false;
};

function ac(number: string | number): string {
  const num = Number(number);
  if (isNaN(num)) return number.toString();
  if (num === 0) return '0';
  return num.toLocaleString();
}

const totalPay = (item: WageBasicItem): string => {
  let calc = 0;
  calc =
    nc(item.eaBasicPay || 0) + nc(item.eaOverPay || 0) + nc(item.eaNightPay || 0) + nc(item.eaBojonPay || 0) +
    nc(item.eaLunchPay || 0) + nc(item.eaDangPay || 0) + nc(item.eaCarPay || 0) + nc(item.eaChildcarePay || 0) + nc(item.eaLongtermPay || 0) + nc(item.eaSunimPay || 0) +
    nc(item.eaBonus || 0) + nc(item.eaEduPay || 0) + nc(item.eaHolidayPay || 0) + nc(item.eaDayOffPay || 0) +
    nc(item.eaEtcPay || 0) - (nc(item.eaMealDeduct || 0) + nc(item.eaEtcDeduct || 0)) - nc(item.eaYearEnd || 0);
  return ac(calc);
};

const headersArr = ref<Header[]>([
  { title: "No.", key: "index", align: "center", sortable: false },
  {
    title: "기초정보",
    align: "center",
    sortable: false,
    children: [
      { title: "이름", key: "empName", align: "center", sortable: true },
      { title: "직종", key: "empJob", align: "center", sortable: true },
      { title: "보수월액", key: "eaRemuneration", align: "center", sortable: true },
    ],
  },
  {
    title: "근로시간",
    align: "center",
    sortable: false,
    children: [
      { title: "기본", key: "eaWorkTime", align: "center", sortable: true },
    ],
  },
  {
    title: "계약임금",
    align: "center",
    sortable: false,
    children: [
      { title: "시급", key: "eaTimePay", align: "center", sortable: true },
      { title: "기본급", key: "eaBasicPay", align: "center", sortable: true },
      { title: "연장수당", key: "eaOverPay", align: "center", sortable: true },
      { title: "야간수당", key: "eaNightPay", align: "center", sortable: true },
      { title: "보존수당", key: "eaBojonPay", align: "center", sortable: true },
      { title: "중식대", key: "eaLunchPay", align: "center", sortable: true },
      { title: "당직수당", key: "eaDangPay", align: "center", sortable: true },
      { title: "차량비", key: "eaCarPay", align: "center", sortable: true },
      { title: "양육비", key: "eaChildcarePay", align: "center", sortable: true },
    ],
  },
  {
    title: "추가임금",
    align: "center",
    sortable: false,
    children: [
      { title: "장기근속", key: "eaLongtermPay", align: "center", sortable: true },
      { title: "선임수당", key: "eaSunimPay", align: "center", sortable: true },
      { title: "상여금", key: "eaBonus", align: "center", sortable: true },
      { title: "교육비", key: "eaEduPay", align: "center", sortable: true },
      { title: "휴일수당", key: "eaHolidayPay", align: "center", sortable: true },
      { title: "연차수당", key: "eaDayOffPay", align: "center", sortable: true },
      { title: "기타수당", key: "eaEtcPay", align: "center", sortable: true },
    ],
  },
  {
    title: "공제",
    align: "center",
    sortable: false,
    children: [
      { title: "식비공제", key: "eaMealDeduct", align: "center", sortable: true },
      { title: "기타공제", key: "eaEtcDeduct", align: "center", sortable: true },
      { title: "연말정산", key: "eaYearEnd", align: "center", sortable: true },
    ],
  },
  { title: "총합계", key: "totalPay", align: "center", sortable: true },
  { title: "기능", key: "", align: "center", sortable: false },
]);

const filteredItems = computed(() => {
  if (!search.value) {
    return empWageBasicList.value;
  }
  return empWageBasicList.value.filter((item) => {
    const matchesSearch =
      (item.empName && item.empName.toLowerCase().includes(search.value.toLowerCase())) ||
      (item.empJob && item.empJob.toLowerCase().includes(search.value.toLowerCase()));
    return matchesSearch;
  });
});

function clearFormat(item: WageBasicItem, key: keyof WageBasicItem) {
  const value = item[key];
  if (typeof value === 'string' || typeof value === 'number') {
    (item[key] as string | number) = nc(value);
  }

  if (!item[key] || item[key] === "0" || item[key] === 0 || item[key] === "-0") {
    (item[key] as string | number) = "";
  }
}

function applyFormat(item: WageBasicItem, key: keyof WageBasicItem) {
  const value = item[key];
  if (
    value === "" ||
    value === null ||
    value === undefined ||
    value === "-0"
  ) {
    (item[key] as string | number) = 0;
  } else if (typeof value === 'string' || typeof value === 'number') {
    (item[key] as string | number) = formatNumber(value);
  }
}

function formatNumber(value: string | number): string {
  const number = parseFloat(value.toString());
  if (!isNaN(number)) {
    return number.toLocaleString();
  }
  return value.toString();
}

function nc(value: string | number | null): number {
  if (value == null) {
    return 0;
  }
  return parseFloat(value.toString().replace(/,/g, ""));
}

const getEmpWageBasic = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get(`/api/getEmpWageBasic/${code.value}/${date.value}`);
    const responseData = response.data;
    if (responseData) {
      empWageBasicList.value = responseData.result;
      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  } finally {
    await getEndEmpAtt();
    loading.value = false;
  }
};
watch(
  () => store.state.AdminYYMM,
  (newValue) => {
    if (newValue) {
      date.value = newValue;
      getEmpWageBasic();
    }
  }
);
const updateEmpWageBasic = async (item: WageBasicItem) => {
  if (loading.value) return;
  const workTime = typeof item.eaWorkTime === 'string' ? parseInt(item.eaWorkTime) : item.eaWorkTime;
  const overTime = typeof item.eaOverTime === 'string' ? parseInt(item.eaOverTime || '0') : (item.eaOverTime || 0);
  const nightTime = typeof item.eaNightTime === 'string' ? parseInt(item.eaNightTime || '0') : (item.eaNightTime || 0);
  const holidayTime = typeof item.eaHolidayTime === 'string' ? parseInt(item.eaHolidayTime || '0') : (item.eaHolidayTime || 0);

  if (workTime > 299) {
    alert("기본근로시간을 확인해주세요.");
    return;
  } else if (overTime > 99) {
    alert("연장근로시간을 확인해주세요.");
    return;
  } else if (nightTime > 299) {
    alert("야간근로시간을 확인해주세요.");
    return;
  } else if (holidayTime > 99) {
    alert("휴일근로시간을 확인해주세요.");
    return;
  }
  // 1주 최대 근로시간은 법정근로시간 40시간, 연장근로 12시간, 휴일근로 16시간(사업장에 따라 휴일이 1일인 경우 8시간)이 가능하여 총 68시간(60시간) 근로가 가능하였습니다.
  const isConfirmed = window.confirm(`${item.empName}님의 정보를 수정하시겠습니까?`);
  if (isConfirmed) {
    loading.value = true;
    try {
      const response = await axios.post(`/api/updateEmpWageBasic/`, { form: item });
      const result = response.data;
      if (result.success === true) {
        console.log("수정완료");
      } else {
        alert("근무내역 수정에 실패하였습니다. 관리자에게 문의해주세요.");
      }
    } catch (error) {
      alert("근무내역 수정을 처리할 수 없습니다.");
      console.error(error);
    } finally {
      loading.value = false;
      item.isEditing = false;
    }
  } else {
    return;
  }
};

const updateAllEmpWageBasic = async () => {
  if (loading.value) return;
  for (const item of empWageBasicList.value) {
    const workTime = typeof item.eaWorkTime === 'string' ? parseInt(item.eaWorkTime) : item.eaWorkTime;
    const overTime = typeof item.eaOverTime === 'string' ? parseInt(item.eaOverTime || '0') : (item.eaOverTime || 0);
    const nightTime = typeof item.eaNightTime === 'string' ? parseInt(item.eaNightTime || '0') : (item.eaNightTime || 0);
    const holidayTime = typeof item.eaHolidayTime === 'string' ? parseInt(item.eaHolidayTime || '0') : (item.eaHolidayTime || 0);

    if (isNaN(workTime) || workTime > 299) {
      alert("기본근로시간을 확인해주세요.");
      return;
    } else if (isNaN(overTime) || overTime > 99) {
      alert("연장근로시간을 확인해주세요.");
      return;
    } else if (isNaN(nightTime) || nightTime > 299) {
      alert("야간근로시간을 확인해주세요.");
      return;
    } else if (isNaN(holidayTime) || holidayTime > 99) {
      alert("휴일근로시간을 확인해주세요.");
      return;
    }
  }
  // 1주 최대 근로시간은 법정근로시간 40시간, 연장근로 12시간, 휴일근로 16시간(사업장에 따라 휴일이 1일인 경우 8시간)이 가능하여 총 68시간(60시간) 근로가 가능하였습니다.
  const isConfirmed = window.confirm("모든 정보를 저장하시겠습니까?");
  if (isConfirmed) {
    loading.value = true;
    try {
      const response = await axios.post(`/api/updateAllEmpWageBasic/`, {
        form: empWageBasicList.value,
      });
      const result = response.data;
      if (result.success === true) {
        console.log("수정완료");
      } else {
        alert("저장에 실패하였습니다. 관리자에게 문의해주세요.");
      }
    } catch (error) {
      alert("저장할 수 없습니다. 입력된 정보를 확인해주세요.");
      console.error(error);
    } finally {
      loading.value = false;
      getEmpWageBasic();
    }
  } else {
    return;
  }
};
const deleteAllEmpAtt = async () => {
  try {
    const isConfirmed = window.confirm("모든 정보를 정말 삭제하시겠습니까?");
    if (isConfirmed) {
      const form = empWageBasicList.value.map((item) => item.empNum);
      const response = await axios.post(
        `/api/deleteAllEmpAtt/${code.value}/${date.value}`,
        { form: form }
      );
      const result = response.data;
      if (result.success === true) {
        await getEmpWageBasic();
        alert("삭제가 완료되었습니다.");
      } else {
        alert("삭제에 실패하였습니다. 관리자에게 문의해주세요.");
      }
    } else {
      return;
    }
  } catch (error) {
    alert("삭제작업을 처리할 수 없습니다.");
    console.error(error);
  }
};

//마감///////////////////////////////////////////////////////////////////////////////////////////
const getEndEmpAtt = async () => {
  try {
    const response = await axios.get(`/api/getEndEmpAtt/${code.value}/${date.value}`);
    const result = response.data;
    if (result.success === true) {
      endEmpStatus.value = false;
    } else {
      endEmpStatus.value = true;
    }
  } catch (error) {
    console.error("errorMsg:", error);
  }
};
function formatDate(dateString: string) {
  const [year, month] = dateString.split("-");
  return `${year}년 ${parseInt(month, 10)}월`;
}
const endEmpWage = async () => {
  try {
    if (empWageBasicList.value.length === 0) {
      alert("임금기초를 작성해주세요.");
      return;
    }
    const isConfirmed = window.confirm(
      `${formatDate(date.value)} 임금기초를 마감하시겠습니까?`
    );
    if (isConfirmed) {
      const response = await axios.post(`/api/endEmpWage/${code.value}/${date.value}`);
      const result = response.data;

      if (result.success === true) {
        await getEmpWageBasic();
        alert("마감이 완료되었습니다.");
        router.push('/WageLedger')
      } else {
        alert("마감에 실패하였습니다. 관리자에게 문의해주세요.");
      }
    } else {
      return;
    }
  } catch (error) {
    alert("작업을 처리할 수 없습니다.");
    console.error(error);
  }
};
const cancelEndEmpAtt = async () => {
  try {
    if (empWageBasicList.value.length === 0) {
      alert("임금기초를 작성해주세요.");
      return;
    }
    const isConfirmed = window.confirm(
      `${formatDate(date.value)} 임금기초 마감을 해제하시겠습니까?`
    );
    if (isConfirmed) {
      const response = await axios.post(
        `/api/cancelEndEmpAtt/${code.value}/${date.value}`
      );
      const result = response.data;
      if (result.success === true) {
        await getEmpWageBasic();
        alert("마감 해제가 완료되었습니다.");
      } else {
        alert("마감 해제를 실패하였습니다. 관리자에게 문의해주세요.");
      }
    } else {
      return;
    }
  } catch (error) {
    alert("작업을 처리할 수 없습니다.");
    console.error(error);
  }
};

onMounted(async () => {
  await getEmpWageBasic();
});
onUnmounted(() => {
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (loading.value)
    ? (_openBlock(), _createBlock(AdminLoadingAction, { key: 0 }))
    : (_openBlock(), _createBlock(_component_v_container, {
        key: 1,
        fluid: "",
        class: "pa-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "rounded-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_icon, {
                      color: "primary",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-account-cash")
                      ]),
                      _: 1
                    }),
                    _hoisted_2,
                    _createVNode(FormatMonth)
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_divider, {
                      class: "mx-4",
                      inset: "",
                      vertical: ""
                    }),
                    _createVNode(WageBasicLoadNowEmp, {
                      onSuccess: _cache[0] || (_cache[0] = ($event: any) => (getEmpWageBasic()))
                    }),
                    _createVNode(_component_v_divider, {
                      class: "mx-4",
                      inset: "",
                      vertical: ""
                    }),
                    _createVNode(WageBasicLoadEmp, {
                      onSuccess: _cache[1] || (_cache[1] = ($event: any) => (getEmpWageBasic()))
                    }),
                    _createVNode(_component_v_divider, {
                      class: "mx-4",
                      inset: "",
                      vertical: ""
                    }),
                    _createVNode(_component_v_menu, { "offset-y": "" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({ class: "btnColorWhite" }, props), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-content-save")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 저장/삭제 ▾ ")
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (updateAllEmpWageBasic())),
                                  class: "btnColorUpdate"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-content-save")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 일괄 저장 ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_list_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteAllEmpAtt())),
                                  class: "btnColorDark"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-delete")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 일괄 삭제 ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_divider, {
                      class: "mx-4",
                      inset: "",
                      vertical: ""
                    }),
                    _createVNode(WageLedgerPayDate),
                    _createVNode(_component_v_divider, {
                      class: "mx-4",
                      inset: "",
                      vertical: ""
                    }),
                    (endEmpStatus.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "btnColorPurple",
                          onClick: endEmpWage
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-lock")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 마감 ")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          class: "btnColorPurple",
                          onClick: cancelEndEmpAtt
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-lock-open")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 마감해제 ")
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_v_divider, {
                      class: "mx-4",
                      inset: "",
                      vertical: ""
                    }),
                    _createVNode(_component_v_text_field, {
                      class: "inoutSearchInput",
                      style: {"background-color":"#fff","max-width":"200px","width":"auto","min-width":"190px","margin":"0 20px 0 0"},
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search).value = $event)),
                      color: "#0f7545",
                      label: "이름/직종 검색",
                      "single-line": "",
                      clearable: "",
                      "append-inner-icon": "mdi-magnify",
                      flat: "",
                      "hide-details": "auto",
                      variant: "outlined",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, { class: "pt-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    "no-data-text": "데이터가 존재하지 않습니다.",
                    "fixed-header": "",
                    density: "compact",
                    scrollable: "",
                    headers: headersArr.value,
                    items: filteredItems.value,
                    search: search.value,
                    "item-value": "name",
                    class: "empWageBasicTb",
                    "items-per-page": -1,
                    "items-per-page-options": [
                { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' },
              ]
                  }, {
                    item: _withCtx(({ item, index }) => [
                      _createElementVNode("tr", {
                        class: "empWageBasicTbTr",
                        onDblclick: ($event: any) => (onEdit(item)),
                        onKeydown: ($event: any) => (handleKeydown(item, $event))
                      }, [
                        _createElementVNode("td", _hoisted_5, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", _hoisted_6, [
                          _createTextVNode(_toDisplayString(item.empName), 1),
                          (item.emp_status === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(item.emp_out_date) + "퇴사)", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(item.empJob), 1),
                        (!item.isEditing)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("td", _hoisted_9, _toDisplayString(item.eaRemuneration), 1),
                              _createElementVNode("td", _hoisted_10, _toDisplayString(item.eaWorkTime), 1),
                              _createElementVNode("td", _hoisted_11, _toDisplayString(item.eaTimePay), 1),
                              _createElementVNode("td", _hoisted_12, _toDisplayString(item.eaBasicPay), 1),
                              _createElementVNode("td", _hoisted_13, _toDisplayString(item.eaOverPay), 1),
                              _createElementVNode("td", _hoisted_14, _toDisplayString(item.eaNightPay), 1),
                              _createElementVNode("td", _hoisted_15, _toDisplayString(item.eaBojonPay), 1),
                              _createElementVNode("td", _hoisted_16, _toDisplayString(item.eaLunchPay), 1),
                              _createElementVNode("td", _hoisted_17, _toDisplayString(item.eaDangPay), 1),
                              _createElementVNode("td", _hoisted_18, _toDisplayString(item.eaCarPay), 1),
                              _createElementVNode("td", _hoisted_19, _toDisplayString(item.eaChildcarePay), 1),
                              _createElementVNode("td", _hoisted_20, _toDisplayString(item.eaLongtermPay), 1),
                              _createElementVNode("td", _hoisted_21, _toDisplayString(item.eaSunimPay), 1),
                              _createElementVNode("td", _hoisted_22, _toDisplayString(item.eaBonus), 1),
                              _createElementVNode("td", _hoisted_23, _toDisplayString(item.eaEduPay), 1),
                              _createElementVNode("td", _hoisted_24, _toDisplayString(item.eaHolidayPay), 1),
                              _createElementVNode("td", _hoisted_25, _toDisplayString(item.eaDayOffPay), 1),
                              _createElementVNode("td", _hoisted_26, _toDisplayString(item.eaEtcPay), 1),
                              _createElementVNode("td", _hoisted_27, _toDisplayString(item.eaMealDeduct), 1),
                              _createElementVNode("td", _hoisted_28, _toDisplayString(item.eaEtcDeduct), 1),
                              _createElementVNode("td", _hoisted_29, _toDisplayString(item.eaYearEnd), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaRemuneration,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaRemuneration) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaRemuneration')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaRemuneration')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaWorkTime,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaWorkTime) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaWorkTime')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaWorkTime')),
                                  maxlength: "4"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaTimePay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaTimePay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaTimePay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaTimePay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaBasicPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaBasicPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaBasicPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaBasicPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaOverPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaOverPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaOverPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaOverPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaNightPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaNightPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaNightPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaNightPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaBojonPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaBojonPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaBojonPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaBojonPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaLunchPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaLunchPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaLunchPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaLunchPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaDangPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaDangPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaDangPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaDangPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaCarPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaCarPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaCarPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaCarPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaChildcarePay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaChildcarePay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaChildcarePay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaChildcarePay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaLongtermPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaLongtermPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaLongtermPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaLongtermPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaSunimPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaSunimPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaSunimPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaSunimPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaBonus,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaBonus) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaBonus')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaBonus')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaEduPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaEduPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaEduPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaEduPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaHolidayPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaHolidayPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaHolidayPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaHolidayPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaDayOffPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaDayOffPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaDayOffPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaDayOffPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaEtcPay,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaEtcPay) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaEtcPay')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaEtcPay')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaMealDeduct,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaMealDeduct) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaMealDeduct')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaMealDeduct')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaEtcDeduct,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaEtcDeduct) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaEtcDeduct')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaEtcDeduct')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_text_field, {
                                  type: "text",
                                  variant: "plain",
                                  modelValue: item.eaYearEnd,
                                  "onUpdate:modelValue": ($event: any) => ((item.eaYearEnd) = $event),
                                  "hide-details": "auto",
                                  onFocus: ($event: any) => (clearFormat(item, 'eaYearEnd')),
                                  onBlur: ($event: any) => (applyFormat(item, 'eaYearEnd')),
                                  maxlength: "12"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])
                              ])
                            ], 64)),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(totalPay(item) || 0), 1),
                        (endEmpStatus.value)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                              (item.isEditing)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 0,
                                    onClick: ($event: any) => (updateEmpWageBasic(item)),
                                    color: "green-darken-3",
                                    class: "SsDeleteIcon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-content-save")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (item.isEditing)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    onClick: ($event: any) => (outEdit(item)),
                                    color: "blue-darken-3",
                                    class: "SsDeleteIcon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-pen-remove")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (!item.isEditing)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 2,
                                    onClick: ($event: any) => (onEdit(item)),
                                    color: "blue-darken-3",
                                    class: "SsDeleteIcon"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-pen")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              (!item.isEditing)
                                ? (_openBlock(), _createBlock(WageBasicEmpDelete, {
                                    key: 3,
                                    item: item,
                                    onSuccess: _cache[5] || (_cache[5] = ($event: any) => (getEmpWageBasic()))
                                  }, null, 8, ["item"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_32, _hoisted_34))
                      ], 40, _hoisted_4)
                    ]),
                    _: 1
                  }, 8, ["headers", "items", "search", "items-per-page-options"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})